import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { products } from '../../data/products';
import ProductImageGallery from '../../components/ProductImageGallery';
import RelatedProducts from '../../components/RelatedProducts';
import { useCart } from '../../context/CartContext';

const EssentialOilSet = () => {
  const product = products.find(p => p.id === 19) || products[18]; // Essential Oil Set
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedEssentialOil, setSelectedEssentialOil] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState('/images/shop-products/essential-oil-set/lemon.jpg');

  const images = [
    "/images/shop-products/essential-oil-set/lemon.jpg",
    "/images/shop-products/essential-oil-set/rose.jpg",
    "/images/shop-products/essential-oil-set/lavender.jpg",
    "/images/shop-products/essential-oil-set/lily.jpg",
    "/images/shop-products/essential-oil-set/white tea.jpg",
    "/images/shop-products/essential-oil-set/Jasmine.jpg"
  ];

  const essentialOils = [
    { name: 'Lemon', image: '/images/shop-products/essential-oil-set/lemon.jpg' },
    { name: 'Rose', image: '/images/shop-products/essential-oil-set/rose.jpg' },
    { name: 'Lavender', image: '/images/shop-products/essential-oil-set/lavender.jpg' },
    { name: 'Lily', image: '/images/shop-products/essential-oil-set/lily.jpg' },
    { name: 'White Tea', image: '/images/shop-products/essential-oil-set/white tea.jpg' },
    { name: 'Jasmine', image: '/images/shop-products/essential-oil-set/Jasmine.jpg' }
  ];

  const allImages = [mainImage, ...images];

  const breadcrumbs = [
    { name: 'Home', href: '/' },
    { name: 'Home & Decor', href: '/category/home-decor' },
    { name: product.name, href: '#' }
  ];

  const relatedProducts = products
    .filter(p => p.category === 'home-decor' && p.id !== product.id)
    .slice(0, 4);

  return (
    <div className="min-h-screen bg-gray-900">

      {/* Breadcrumbs */}
      <div className="bg-gray-800 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex" aria-label="Breadcrumb">
            <ol className="flex items-center space-x-4">
              {breadcrumbs.map((crumb, index) => (
                <li key={crumb.name}>
                  <div className="flex items-center">
                    {index > 0 && (
                      <svg className="flex-shrink-0 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                    )}
                    <Link
                      to={crumb.href}
                      className={`text-sm font-medium ${
                        index === breadcrumbs.length - 1
                          ? 'text-white'
                          : 'text-gray-400 hover:text-white'
                      }`}
                    >
                      {crumb.name}
                    </Link>
                  </div>
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Product Images */}
          <div className="space-y-4">
            <ProductImageGallery
              images={allImages}
              currentImage={mainImage}
              onImageChange={(image) => {
                setMainImage(image);
              }}
            />
          </div>

          {/* Product Details */}
          <div className="space-y-6">
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">
                Hotel-Inspired Home Fragrance – Water-Soluble Aroma Oil, Smokeless (10ml)
              </h1>
              <div className="flex items-center space-x-4 mb-4">
                <div className="flex items-center">
                  <span className="text-3xl font-bold text-green-400">S$4.90</span>
                  <span className="text-xl text-gray-400 line-through ml-2">S$6.90</span>
                </div>
                <span className="bg-red-600 text-white px-2 py-1 rounded text-sm font-medium">
                  29% OFF
                </span>
              </div>
              <p className="text-gray-300 text-lg">
                Hotel-inspired water-soluble aroma oil for creating luxurious home fragrance without smoke or residue. 
                Perfect for diffusers, humidifiers, or simply adding to water for instant premium fragrance.
              </p>
            </div>

            {/* Choose Fragrance */}
            <div>
              <h3 className="text-lg font-medium mb-4">Choose Fragrance</h3>
              <div className="grid grid-cols-2 gap-4">
                {essentialOils.map((oil) => (
                  <button
                    key={oil.name}
                    className={`border-2 rounded-lg p-4 transition-all duration-200 ${
                      selectedEssentialOil === oil.name
                        ? 'border-green-500 bg-green-500/10'
                        : 'border-gray-700 hover:border-green-400'
                    }`}
                    onClick={() => setSelectedEssentialOil(selectedEssentialOil === oil.name ? null : oil.name)}
                  >
                    <div className="flex items-center space-x-3">
                      <img
                        src={oil.image}
                        alt={oil.name}
                        className="w-12 h-12 rounded-lg object-cover flex-shrink-0"
                        onError={(e) => {
                          e.target.src = '/images/products/placeholder.jpg';
                        }}
                      />
                      <div className="text-left">
                        <div className="text-white font-medium">{oil.name}</div>
                        <div className="text-gray-400 text-sm">Hotel-Inspired</div>
                      </div>
                      {selectedEssentialOil === oil.name && (
                        <div className="ml-auto">
                          <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          </div>
                        </div>
                      )}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Quantity */}
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Quantity</label>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  className="w-10 h-10 rounded-lg border border-gray-600 text-gray-300 hover:border-gray-400 transition-colors"
                >
                  -
                </button>
                <span className="w-16 text-center text-lg font-medium">{quantity}</span>
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="w-10 h-10 rounded-lg border border-gray-600 text-gray-300 hover:border-gray-400 transition-colors"
                >
                  +
                </button>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="space-y-4">
              <button
                className={`w-full font-bold py-4 px-6 rounded-lg transition-colors ${
                  selectedEssentialOil
                    ? 'bg-green-600 hover:bg-green-700 text-white'
                    : 'bg-gray-500 text-gray-300 cursor-not-allowed'
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  if (!selectedEssentialOil) return;
                  const totalPrice = parseFloat(product.price.replace(/^S\$/, '')) * quantity;
                  addToCart({
                    id: product.id,
                    name: product.name,
                    price: `S$${totalPrice.toFixed(2)}`,
                    image: product.image,
                    quantity: quantity,
                    selectedEssentialOil: selectedEssentialOil
                  });
                }}
                disabled={!selectedEssentialOil}
              >
                                {selectedEssentialOil
                  ? `Add to Cart - S$${(parseFloat(product.price.replace(/^S\$/, '')) * quantity).toFixed(2)}`
                  : 'Please Select Fragrance'
                }
              </button>
              <button
                className={`w-full font-bold py-4 px-6 rounded-lg transition-colors ${
                  selectedEssentialOil
                    ? 'bg-gray-700 hover:bg-gray-600 text-white'
                    : 'bg-gray-500 text-gray-300 cursor-not-allowed'
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  if (!selectedEssentialOil) return;
                  const totalPrice = parseFloat(product.price.replace(/^S\$/, '')) * quantity;
                  addToCart({
                    id: product.id,
                    name: product.name,
                    price: `S$${totalPrice.toFixed(2)}`,
                    image: product.image,
                    quantity: quantity,
                    selectedEssentialOil: selectedEssentialOil
                  });
                  navigate('/cart');
                }}
                disabled={!selectedEssentialOil}
              >
                {selectedEssentialOil ? 'Buy Now' : 'Please Select Fragrance'}
              </button>
            </div>

            {/* Shipping Info */}
            <div className="bg-gray-800 p-4 rounded-lg">
              <div className="flex items-center space-x-3">
                <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                 <div>
                   <p className="font-medium text-white">Free Meet Up (Available at Sengkang & Orchard locations)</p>
                   <p className="text-sm text-gray-400">Available Shipping</p>
                 </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Tabs */}
        <div className="mt-16">
          <div className="border-b border-gray-700">
            <nav className="flex space-x-8">
              {['overview', 'specifications', 'reviews'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab
                      ? 'border-green-500 text-green-400'
                      : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300'
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </nav>
          </div>

          <div className="py-8">
            {activeTab === 'overview' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* Product Overview */}
                <div>
                  <h3 className="text-2xl font-bold text-white mb-6">Product Overview</h3>
                  <div className="space-y-4 text-white">
                    <p>
                      Experience the luxury of hotel-quality home fragrance with our water-soluble aroma oil. 
                      This innovative formula creates a sophisticated atmosphere without smoke, residue, or harmful chemicals, 
                      bringing the essence of high-end hotels directly to your home.
                    </p>
                    <p>
                      The water-soluble technology ensures even distribution and long-lasting fragrance throughout your space. 
                      Perfect for creating a welcoming environment for guests, relaxation, or simply enjoying a premium 
                      home fragrance experience without the mess of traditional oils.
                    </p>
                    <p>
                      Ideal for use in diffusers, humidifiers, or simply adding a few drops to water. 
                      The 10ml size provides long-lasting fragrance while the high-quality glass bottle 
                      ensures easy and precise application for any space.
                    </p>
                  </div>
                </div>

                {/* Key Features */}
                <div>
                  <h3 className="text-2xl font-bold text-white mb-6">Key Features</h3>
                  <ul className="space-y-4">
                    <li className="flex items-start">
                      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <div className="text-white font-medium mb-1">Water-Soluble Formula</div>
                        <div className="text-gray-300 text-sm">Advanced water-soluble technology ensures even distribution and long-lasting fragrance without residue</div>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <div className="text-white font-medium mb-1">Smokeless Operation</div>
                        <div className="text-gray-300 text-sm">No smoke, no residue, no harmful chemicals - clean and safe for all environments</div>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <div className="text-white font-medium mb-1">Hotel-Quality Fragrance</div>
                        <div className="text-gray-300 text-sm">Premium fragrance blend inspired by luxury hotels for a sophisticated home atmosphere</div>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <div className="text-white font-medium mb-1">10ml Convenient Size</div>
                        <div className="text-gray-300 text-sm">Perfect 10ml size provides long-lasting fragrance while being easy to store and use</div>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <svg className="w-6 h-6 mr-3 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      <div>
                        <div className="text-white font-medium mb-1">Versatile Usage</div>
                        <div className="text-gray-300 text-sm">Perfect for diffusers, humidifiers, or simply adding to water for instant fragrance</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                {/* Product Specifications */}
                <div>
                  <h3 className="text-2xl font-bold text-white mb-6">Product Specifications</h3>
                  <div className="space-y-4">
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Volume</span>
                      <span className="text-white font-medium">10ml</span>
                    </div>
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Type</span>
                      <span className="text-white font-medium">Water-Soluble</span>
                    </div>
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Smoke</span>
                      <span className="text-white font-medium">Smokeless</span>
                    </div>
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Purity Level</span>
                      <span className="text-white font-medium">100% Pure</span>
                    </div>
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Bottle Material</span>
                      <span className="text-white font-medium">Glass</span>
                    </div>
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Fragrance Type</span>
                      <span className="text-white font-medium">Hotel-Inspired</span>
                    </div>
                    <div className="flex justify-between py-3 border-b border-gray-700">
                      <span className="text-gray-400">Usage</span>
                      <span className="text-white font-medium">Diffusers & Water</span>
                    </div>
                    <div className="flex justify-between py-3">
                      <span className="text-gray-400">Shelf Life</span>
                      <span className="text-white font-medium">2 Years</span>
                    </div>
                  </div>
                </div>

                {/* Features & Benefits */}
                <div>
                  <h3 className="text-2xl font-bold text-white mb-6">Features & Benefits</h3>
                  <div className="space-y-4">
                    <div className="bg-gray-800 p-4 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-white font-medium">Water-Soluble Technology</h4>
                        <span className="text-blue-400 text-sm">Advanced</span>
                      </div>
                      <p className="text-gray-300 text-sm">Revolutionary water-soluble formula ensures even distribution and long-lasting fragrance without residue</p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-white font-medium">Smokeless Operation</h4>
                        <span className="text-green-400 text-sm">Clean</span>
                      </div>
                      <p className="text-gray-300 text-sm">No smoke, no residue, no harmful chemicals - perfect for all environments including bedrooms and offices</p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-white font-medium">Hotel-Quality Fragrance</h4>
                        <span className="text-purple-400 text-sm">Luxury</span>
                      </div>
                      <p className="text-gray-300 text-sm">Premium fragrance blend inspired by luxury hotels for a sophisticated and welcoming home atmosphere</p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-white font-medium">Versatile Usage</h4>
                        <span className="text-orange-400 text-sm">Flexible</span>
                      </div>
                      <p className="text-gray-300 text-sm">Perfect for diffusers, humidifiers, or simply adding a few drops to water for instant fragrance</p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-white font-medium">Long-Lasting</h4>
                        <span className="text-yellow-400 text-sm">Durable</span>
                      </div>
                      <p className="text-gray-300 text-sm">10ml size provides extended fragrance duration while maintaining consistent quality throughout use</p>
                    </div>
                    <div className="bg-gray-800 p-4 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-white font-medium">Easy Application</h4>
                        <span className="text-pink-400 text-sm">Convenient</span>
                      </div>
                      <p className="text-gray-300 text-sm">Simple dropper cap design allows for precise and mess-free application in any setting</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'reviews' && (
              <div className="space-y-6">
                <h3 className="text-2xl font-bold text-white mb-6">Customer Reviews</h3>
                <div className="space-y-4">
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        <div className="flex text-yellow-400">
                          {[...Array(5)].map((_, i) => (
                            <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                              <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                            </svg>
                          ))}
                        </div>
                        <span className="ml-2 text-white font-medium">Sarah M.</span>
                      </div>
                    </div>
                    <p className="text-gray-300">
                      "Amazing quality essential oils! The scents are so pure and authentic. 
                      Perfect for my aromatherapy diffuser. The packaging is beautiful and 
                      the bottles are high quality. Highly recommended!"
                    </p>
                  </div>
                  <div className="bg-gray-800 p-6 rounded-lg">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        <div className="flex text-yellow-400">
                          {[...Array(5)].map((_, i) => (
                            <svg key={i} className="w-5 h-5 fill-current" viewBox="0 0 20 20">
                              <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                            </svg>
                          ))}
                        </div>
                        <span className="ml-2 text-white font-medium">Mike L.</span>
                      </div>
                    </div>
                    <p className="text-gray-300">
                      "Great value for money! All 6 oils are fantastic quality. 
                      The lavender helps me sleep better and the lemon is perfect for 
                      energizing my workspace. Will definitely order again!"
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Related Products */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-white mb-8">Related Products</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {relatedProducts.map((product) => (
              <Link
                key={product.id}
                to={`/product/${product.id}`}
                className="bg-gray-800 rounded-lg overflow-hidden hover:bg-gray-700 transition-colors"
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-48 object-cover"
                />
                <div className="p-4">
                  <h4 className="text-white font-medium mb-2">{product.name}</h4>
                  <div className="flex items-center justify-between">
                    <span className="text-green-400 font-bold">{product.price}</span>
                    {product.originalPrice && (
                      <span className="text-gray-400 line-through text-sm">
                        {product.originalPrice}
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      
      {/* 相关产品 */}
      <RelatedProducts 
        currentProductId={19} 
        currentCategory="home-decor" 
        limit={4} 
      />
    </div>
  );
};

export default EssentialOilSet;
